import {
  CHUNK_FAILED_MESSAGE,
  CHUNK_FAILED_THROTTLE,
  CORE_CHUNK_FAILED_STORAGE_KEY,
} from '../constants'

export const isChunkFailedMessage = (errorMessage: string | undefined) => {
  if (errorMessage?.includes(CHUNK_FAILED_MESSAGE)) {
    return isCheckAvailable()
  }
  return false
}

export const handleChunkError = (errorMessage: string) => {
  setExpiredDate(errorMessage)
  window.location.reload()
}

function setExpiredDate(message: string) {
  const item = {
    message: message || 'Empty message',
    date: new Date().getTime() + CHUNK_FAILED_THROTTLE,
  }
  localStorage.setItem(CORE_CHUNK_FAILED_STORAGE_KEY, JSON.stringify(item))
}

function isCheckAvailable() {
  const itemString = window.localStorage.getItem(CORE_CHUNK_FAILED_STORAGE_KEY)
  if (!itemString) {
    return true
  }

  const item = JSON.parse(itemString)
  const isExpired = new Date().getTime() > item.date

  if (isExpired) {
    localStorage.removeItem(CORE_CHUNK_FAILED_STORAGE_KEY)
    return true
  }

  return false
}
